import type { ReactNode } from 'react';

import { Typography } from '@ui/uikit/components/common/Typography';
import { ProgressBar } from '@ui/uikit/surrogates/ProgressBar';

import styles from './ApplicationValidationProgressBarItem.module.scss';

interface ValidationProgressBarItemProps {
  value?: number;
  label?: string;
  icon?: ReactNode;
}

export const ApplicationValidationProgressBarItem = ({
                                                       value = 50,
                                                       label = '',
                                                       icon,
                                                     }: ValidationProgressBarItemProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.label}>
        {icon && icon}
        <Typography variant="caption-xs-strong">{label}</Typography>
      </div>
      <div className={styles.progressBarWrapper}>
        <ProgressBar
          value={value}
          minValue={0}
          maxValue={100}
          appearance={{
            container: styles.progressBar,
            indicator: {
              paper: styles.paper,
              mask: styles.mask,
            },
          }}
          overrides={{
            '--progress-bar-height': 4,
            '--progress-bar-paper': 'var(--border-color-medium)',
            '--progress-bar-ink': 'var(--text-color-quaternary)',
          }}
        />
        <div className={styles.percentage}>{value}%</div>
      </div>
    </div>
  );
};
